import { useI18n } from 'vue-i18n'

export function parseDateOnlyValue (value) {
  if (!value) return new Date(NaN)
  const s = String(value).trim()
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const [y, m, d] = s.slice(0, 10).split('-').map(Number)
    return new Date(y, m - 1, d)
  }
  const br = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/)
  if (br) return new Date(Number(br[3]), Number(br[2]) - 1, Number(br[1]))
  return new Date(s)
}

export function useRecebiveisDisplay () {
  const { t } = useI18n()

  const formatDateOnly = (value) => {
    const d = parseDateOnlyValue(value)
    if (Number.isNaN(d.getTime())) return value || '—'
    return d.toLocaleDateString('pt-BR')
  }

  const recebivelStatusKey = (item) => {
    if (item?.pago) return 'paid'
    const hoje = new Date()
    hoje.setHours(0, 0, 0, 0)
    const venc = parseDateOnlyValue(item?.dataVencimento)
    if (Number.isNaN(venc.getTime())) return 'open'
    const diffDias = Math.ceil((venc.getTime() - hoje.getTime()) / 86400000)
    if (diffDias < 0) return 'overdue'
    if (diffDias <= 5) return 'due-soon'
    return 'open'
  }

  const recebivelStatusClass = (item) => `recebivel-card--${recebivelStatusKey(item)}`

  const recebivelStatusLabel = (item) => {
    if (item?.pago) return t('kanban.taskDetail.sections.finance.statusPaid')
    const hoje = new Date()
    hoje.setHours(0, 0, 0, 0)
    const venc = parseDateOnlyValue(item?.dataVencimento)
    if (Number.isNaN(venc.getTime())) return t('kanban.taskDetail.sections.finance.statusOpen')
    const diffDias = Math.ceil((venc.getTime() - hoje.getTime()) / 86400000)
    if (diffDias < 0) return t('kanban.taskDetail.sections.finance.statusOverdue')
    if (diffDias <= 5) return t('kanban.taskDetail.sections.finance.statusDueIn', { days: diffDias })
    return t('kanban.taskDetail.sections.finance.statusOnTime')
  }

  const recebivelBadgeClass = (item) => `recebivel-card__badge--${recebivelStatusKey(item)}`

  const recebivelBarClass = (item) => {
    if (item?.pago) return 'recebivel-card__bar--paid'
    const hoje = new Date()
    hoje.setHours(0, 0, 0, 0)
    const venc = parseDateOnlyValue(item?.dataVencimento)
    if (Number.isNaN(venc.getTime())) return 'recebivel-card__bar--due'
    const diffDias = Math.ceil((venc.getTime() - hoje.getTime()) / 86400000)
    if (diffDias < 0) return 'recebivel-card__bar--overdue'
    return 'recebivel-card__bar--due'
  }

  return {
    formatDateOnly,
    recebivelStatusKey,
    recebivelStatusClass,
    recebivelStatusLabel,
    recebivelBadgeClass,
    recebivelBarClass
  }
}
